import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Button, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useResponsiveButtonSize, useSecondaryButtonTheme } from '../../../../utils/hooks';
import { closeFormLayoutModal, saveAndCloseFormLayoutModal } from '../../../../actions/formLayoutModal';
import { useApplicationContext } from '../../../ApplicationContext';
import { usePersistentState } from '../../../../utils/persistentState';
import { jsx as _jsx } from "react/jsx-runtime";
export var ModalButtonCloseContainer = function ModalButtonCloseContainer(props) {
  var _useApplicationContex = useApplicationContext(),
    layoutConfiguration = _useApplicationContex.layoutConfiguration;
  var _usePersistentState = usePersistentState(),
    isAvailable = _usePersistentState.isAvailable,
    valuesToSave = _usePersistentState.valuesToSave;
  var dispatch = useDispatch();
  var size = useResponsiveButtonSize();
  var theme = useSecondaryButtonTheme();
  var deviceType = useDeviceType();
  var isSaveAndCloseButton = props.saveEnabled && isAvailable() && layoutConfiguration.footer.closeButton.type === 'save_close';
  var text = isSaveAndCloseButton ? 'Сохранить и закрыть' : 'Закрыть';
  var handleClose = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!isSaveAndCloseButton) {
            _context.next = 5;
            break;
          }
          _context.next = 3;
          return dispatch(saveAndCloseFormLayoutModal(valuesToSave));
        case 3:
          _context.next = 7;
          break;
        case 5:
          _context.next = 7;
          return dispatch(closeFormLayoutModal(valuesToSave));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [dispatch, isSaveAndCloseButton, valuesToSave]);
  return /*#__PURE__*/_jsx(Button, {
    fullWidth: deviceType === 'phone',
    theme: props.theme || theme,
    size: size,
    onClick: handleClose,
    children: props.text || text
  });
};